import { orchestrator } from 'satcheljs';
import { newCalendarEventCreated } from 'owa-calendar-events-actions';
import { isSelectedCalendar } from 'owa-calendar-surface-calendars-store';
import { selectCalendar } from 'owa-calendar-surface-select-calendar';
import { getCalendarEntries, getCalculatedFolderIdByCalendarID } from 'owa-calendar-cache';

// TODO: VSO #88707 Separate module vs surface concerns in Calendar module
// Eventually should move to a more meaningful package closer to surface view store

orchestrator(newCalendarEventCreated, actionMessage => {
    const [calendar] = getCalendarEntries().filter(
        cal => getCalculatedFolderIdByCalendarID(cal.calendarId.id) === actionMessage.parentFolderId
    );

    if (calendar && !isSelectedCalendar(calendar)) {
        selectCalendar(calendar);
    }
});
